    import React                                from "react";
    import { useNavigate }                      from "react-router-dom";
    import SentimentVeryDissatisfiedRoundedIcon from "@mui/icons-material/SentimentVeryDissatisfiedRounded";
    import { 
        Box, 
        Typography, 
        Button 
    } from "@mui/material";


    const NotFoundPage = () => {
    const navigate = useNavigate();

    const goHome = () => {
        sessionStorage.clear();
        navigate("/"); 
    };

    return (
        <Box
        sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            textAlign: "center",
            p: 3,
        }}
        >
        <SentimentVeryDissatisfiedRoundedIcon
            sx={{ fontSize: 200, color: "#263F78" }}
        />
        <Typography
            variant="h1"
            component="h2"
            gutterBottom
            sx={{ color: "#263F78" }}
        >
            404
        </Typography>
        <Typography variant="h5" gutterBottom>
            Oops! La pagina che stavi cercando non esiste.
        </Typography>
        <Button
            variant="contained"
            onClick={goHome}
            sx={{
            mt: 3,
            backgroundColor: "#263F78",
            color: "white",
            "&:hover": {
                backgroundColor: "#263F78",
                color: "white",
                transform: "scale(1.01)",
            },
            }}
        >
            Torna alla Login
        </Button>
        </Box>
    );
    };

    export default NotFoundPage;
